import { Component, OnInit } from '@angular/core';
import { BasketsService } from 'src/app/services/baskets.service';
import { MatSnackBar } from '@angular/material';

@Component({
  selector: 'app-baskets-table',
  templateUrl: './baskets-table.component.html',
  styleUrls: ['./baskets-table.component.css']
})
export class BasketsTableComponent implements OnInit {

  public baskets: [];

  constructor(private basketsService: BasketsService, private snackBar: MatSnackBar) { }

  ngOnInit() {
    this.basketsService.getBasketsAsAdmin().subscribe(result => {
      this.baskets = result.data;
    }, error => {
      this.snackBar.open(error.error.data, 'Dismiss', {
        duration: 3000
      });
    });
  }
}
